import { Action } from '@ngrx/store';
import { AnnuitantDoctor } from 'src/app/model/ngrx/health-records.model';

export const ADD_HEALTH_RECORDS = '[HEALTH_RECORDS] Add';
export const REMOVE_HEALTH_RECORDS = '[HEALTH_RECORDS] Remove';

// AddPersonalDetails
export class AddHealthRecords implements Action {
    readonly type = ADD_HEALTH_RECORDS;

    constructor(public payload: AnnuitantDoctor) { }
}
// RemovePersonalDetails
export class RemoveHealthRecords implements Action {
    readonly type = REMOVE_HEALTH_RECORDS;

    constructor(public payload: number) { }
}

export type HealthRecordActions = AddHealthRecords | RemoveHealthRecords;
